// PURL
export enum PurlType {
    NONE = 'NONE',
    MOCK = 'MOCK',
    SAVE = 'SAVE',
}
type PurlBase = {
    name: string;
    type: PurlType;
    status?: string;
    valid?: boolean;
};
export type Purl = PurlBase & {
    json: object | undefined;
    response: object | undefined;
};
export type PurlActive = PurlBase & {
    json: string;
    response: string;
};

// SAVED PURLS STORE
export type SavedPurlsData = {
    items: Purl[];
    activeItem: PurlActive;
};
type SavedPurlsMethods = {
    setList: () => void;
    setActive: (purl: Purl) => void;
    saveActive: (purlType: PurlType) => void;
    postActive: () => void;
    changeActiveProp: (purl: PurlActive, propName: string) => void;
    remove: (name: string) => void;
    unload: () => void;
};
export type SavedPurlsStore = SavedPurlsData & SavedPurlsMethods;

// API LOG STORE
export type ApiLogData = {
    items: Purl[];
    isOn: boolean;
};
type ApiLogMethods = {
    setList: () => void;
    toggle: () => void;
    unload: () => void;
};
export type ApiLogStore = ApiLogData & ApiLogMethods;
